import {
  GetInstagramLoginBindResponse,
  GetInstagramLoginUrlResponse,
  InstagramLoginSetting,
  PostInstagramLoginBindResponse,
} from "../interface/api/instagram-login-api";

export const instagramLoginSettingMapper = {
  mapResponseToInstagramLoginSetting(
    response: PostInstagramLoginBindResponse | GetInstagramLoginBindResponse
  ): InstagramLoginSetting {
    const { instagramLoginSetting } = response?.payload || {};
    return instagramLoginSetting || {};
  },

  mapResponseToLoginUrl(response: GetInstagramLoginUrlResponse): { url: string } {
    return { url: response?.payload?.url || "" };
  },
};
